import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { stepBack } from "services";
import { useStores } from "stores";
import { CustomButton } from "ui";

type Props = {
  id: string | undefined;
};

export const ButtonReturnToEditing = ({ id }: Props) => {
  const { actionModals } = useStores();

  const stepBackHandler = () => {
    if (!id) return;
    actionModals.open(
      () => (
        <ConfirmationModal
          buttonText="Подтвердить"
          text="Вы хотите перейти в редактирование?"
          successText="Вы вернулись в редактирование"
          calledQuery={() => stepBack({ id })}
          // onSuccess={() => {
          //   setTimeout(() => {
          //     window.updateOnboardingElements?.();
          //   }, 1000);
          // }}
        />
      ),
      {
        ...confirmationModalConfigs,
        width: "500px",
        title: "Редактирование",
        onClose: () => actionModals.closeAll(),
      }
    );
  };
  return (
    <CustomButton type="default" tooltip="Вернуться в редактирование" onClick={() => stepBackHandler()}>
      Вернуть на редактирование
    </CustomButton>
  );
};
